var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8691 6.20221C14.166 7.65905 13.9544 9.17363 13.2697 10.4934C12.585 11.8131 11.4686 12.8582 10.1066 13.4545C8.74461 14.0507 7.21938 14.162 5.78527 13.7697C4.35116 13.3775 3.09485 12.5055 2.22586 11.2991C1.35686 10.0927 0.927707 8.62491 1.00996 7.14041C1.09221 5.65591 1.6809 4.24447 2.67785 3.14147C3.6748 2.03848 5.01975 1.31059 6.48841 1.07921C7.95708 0.847825 9.46068 1.12692 10.7485 1.86996",
    stroke: "#00A63E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.9L8.07692 10L15 3",
    stroke: "#00A63E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle_check.b48f3002413ca19d7d9f0a136ce70642.svg";
export { ForwardRef as ReactComponent };